// @ts-nocheck
import styled from 'styled-components';
import { scarpaGray600, scarpaGray800 } from '@habitech/shared';
import { GridContainer } from 'src/components/common/grids';

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: ${scarpaGray800};
`;

export const SearchWrapper = styled(GridContainer)`
    padding: 32px 0;
    align-items: end;
`;

export const Description = styled.p`
    font-size: 14px;
    color: ${scarpaGray600};
`;
